export enum AchPaymentType {
    Regular = 1,
    StateTax = 2,
    FederalTax = 3,
    ChildSupport = 4,
}

export interface TaxAmountDescription {
    amount: number;
    description?: string;
}
